import { render, staticRenderFns } from "./AdvertList.vue?vue&type=template&id=dd1e89a4&scoped=true"
import script from "./AdvertList.vue?vue&type=script&lang=js"
export * from "./AdvertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1e89a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd1e89a4')) {
      api.createRecord('dd1e89a4', component.options)
    } else {
      api.reload('dd1e89a4', component.options)
    }
    module.hot.accept("./AdvertList.vue?vue&type=template&id=dd1e89a4&scoped=true", function () {
      api.rerender('dd1e89a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/AdvertList.vue"
export default component.exports